(function () {
  'use strict';

  /* ----- Flavors horizontal scroll pin ----- */
  var flavorsPin = document.querySelector('.flavors-pin');
  var flavorsTrackInner = document.querySelector('.flavors-track__inner');
  var flavorsProgress = document.getElementById('flavorsProgress');

  function setupFlavorsScroll() {
    if (!flavorsPin || !flavorsTrackInner) return;
    var trackWidth = flavorsTrackInner.scrollWidth;
    var viewportW = window.innerWidth;
    var horizDist = Math.max(0, trackWidth - viewportW + 80);
    var runway = horizDist + window.innerHeight * 0.2;
    flavorsPin.style.height = (window.innerHeight + runway) + 'px';
    flavorsPin.dataset.runway = runway;
    flavorsPin.dataset.dist = horizDist;
  }

  function updateFlavorsScroll() {
    if (!flavorsPin) return;
    var rect = flavorsPin.getBoundingClientRect();
    var runway = parseFloat(flavorsPin.dataset.runway || 0);
    var dist = parseFloat(flavorsPin.dataset.dist || 0);
    var scrolled = -rect.top;
    var progress = Math.max(0, Math.min(1, scrolled / runway));
    flavorsTrackInner.style.transform = 'translate3d(' + (-progress * dist) + 'px, 0, 0)';
    if (flavorsProgress) flavorsProgress.style.width = (progress * 100) + '%';
  }

  window.addEventListener('load', function () {
    setupFlavorsScroll();
    updateFlavorsScroll();
  });
  window.addEventListener('resize', function () {
    setupFlavorsScroll();
    updateFlavorsScroll();
  });
  window.addEventListener('scroll', updateFlavorsScroll, { passive: true });
  setupFlavorsScroll();
  updateFlavorsScroll();

  /* ----- Sticky nav shadow ----- */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----- Reveal on scroll (IntersectionObserver) ----- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) {
    io.observe(el);
  });

  /* ----- Hero parallax (mouse + scroll) ----- */
  var heroStage = document.getElementById('heroStage');
  var heroSection = document.querySelector('.hero');
  if (heroStage && heroSection) {
    var parallaxItems = heroStage.querySelectorAll('[data-parallax]');
    var offsets = new Map();
    parallaxItems.forEach(function (el) {
      offsets.set(el, { mx: 0, my: 0, sy: 0 });
    });

    function applyTranslate(el) {
      var o = offsets.get(el);
      if (!o) return;
      el.style.translate = o.mx + 'px ' + (o.my + o.sy) + 'px';
    }

    var returnTimer = null;

    heroSection.addEventListener('mousemove', function (ev) {
      if (returnTimer) { clearTimeout(returnTimer); returnTimer = null; }
      parallaxItems.forEach(function (it) { it.classList.remove('parallax-return'); });
      var r = heroSection.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5;
      var y = (ev.clientY - r.top) / r.height - 0.5;
      parallaxItems.forEach(function (it) {
        var f = parseFloat(it.dataset.parallax) || 0;
        var o = offsets.get(it);
        o.mx = x * 30 * f * 10;
        o.my = y * 30 * f * 10;
        applyTranslate(it);
      });
    });

    heroSection.addEventListener('mouseleave', function () {
      parallaxItems.forEach(function (it) {
        it.classList.add('parallax-return');
        var o = offsets.get(it);
        o.mx = 0;
        o.my = 0;
        applyTranslate(it);
      });
      returnTimer = setTimeout(function () {
        parallaxItems.forEach(function (it) { it.classList.remove('parallax-return'); });
        returnTimer = null;
      }, 720);
    });

    function updateScrollParallax() {
      var scrollY = window.scrollY;
      parallaxItems.forEach(function (el) {
        var speed = parseFloat(el.dataset.scrollParallax) || 0;
        if (speed === 0) return;
        var o = offsets.get(el);
        o.sy = scrollY * speed;
        applyTranslate(el);
      });
    }

    window.addEventListener('scroll', updateScrollParallax, { passive: true });
    updateScrollParallax();
  }

  /* ----- Active nav link on scroll ----- */
  var sections = ['sabores', 'presentaciones', 'detalle', 'prueba', 'faq']
    .map(function (id) { return document.getElementById(id); })
    .filter(Boolean);
  var navLinks = document.querySelectorAll('.nav__links a');
  var linkIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        navLinks.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
        });
      }
    });
  }, { rootMargin: '-40% 0px -55% 0px' });
  sections.forEach(function (s) { linkIO.observe(s); });

  /* ----- Smooth scroll ----- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var id = a.getAttribute('href');
      if (id.length > 1) {
        var t = document.querySelector(id);
        if (t) {
          ev.preventDefault();
          window.scrollTo({
            top: t.getBoundingClientRect().top + window.scrollY - 70,
            behavior: 'smooth'
          });
        }
      }
    });
  });

  /* ----- FAQ accordion ----- */
  document.querySelectorAll('.faq__item').forEach(function (item) {
    item.querySelector('.faq__q').addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq__item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ----- Flavor card tap feedback ----- */
  document.querySelectorAll('.fcard').forEach(function (card) {
    card.addEventListener('click', function () {
      card.style.transform = 'translateY(-10px) scale(1.01)';
      setTimeout(function () { card.style.transform = ''; }, 250);
    });
  });

})();
